import React, { useEffect, useState } from "react";
import Spinner from "../../../../components/ui/spinner";
import { getUsersData } from "../../../../services/apiservices/support";


const UserStatCard = ({
  label,
  dateFilter,
  companyUsers = null,
  cancel = false,
}) => {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setCount(0);
    setLoading(true);
    getUsersData(dateFilter, companyUsers, cancel).then((data) => {
      setCount(data);
      setLoading(false);
    });
  }, [dateFilter, companyUsers, cancel]);

  return (
    <div className="bg-[#232834] p-16 rounded-lg">
      <div className="flex justify-between items-start">
        <div>
          <p className="text-gray-400 text-sm">{label}</p>
          <p className="text-2xl font-bold">
            {loading ? <Spinner size="sm" /> : count}
          </p>
        </div>
      </div>
    </div>
  );
};

export const NewAccounts = ({ dateFilter }) => (
  <UserStatCard label="New Accounts" dateFilter={dateFilter} companyUsers={null} />
);

export const CancelledAccount = ({ dateFilter }) => (
  <UserStatCard
    label="Cancelled Accounts"
    dateFilter={dateFilter}
    companyUsers={null}
    cancel={true}
  />
);

export const CompanyAccount = ({ dateFilter }) => (
  <UserStatCard
    label="Company Accounts"
    dateFilter={dateFilter}
    companyUsers={true}
  />
);

export const ActiveAccount = ({ dateFilter }) => (
  <UserStatCard
    label="System Accounts"
    dateFilter={dateFilter}
    companyUsers={false}
  />
);
